/*
 * Created on Sat Mar 23 2017
 *
 * Copyright (c) 2019 Sébastien Hecart - Fahbe Mobile App
 *
 *
 *
 */
export default {
  rating_popupTitle: 'Aimez-vous BatiKal ?',
  rating_popupMessage: 'Aidez nous en ajoutant un commentaire.',
  rating_popup_button_ok: 'Ok',
  rating_popup_button_nok: 'Une autre fois',
  rating_popup_button_dont_askme: 'Ne plus me demander pour cette version'
}
